// import React, { Component } from "react";
// import { Link } from "react-router-dom";

// // ============ FontAwesome Icon Library ============
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faEdit } from "@fortawesome/free-solid-svg-icons";

// // ============ MDB Components ============
// import { MDBBtn } from "mdb-react-ui-kit";

// class ResultRow extends Component {
//    render() {
//       const props = this.props;

//       const jobCardNo = props.value["job-card-no"];
//       const unitSlNo = props.value["unit-sl-no"];
//       const vehicleNo = props.value["vehicle-no"];
//       const typeOfService = props.value["type-of-service"];
//       const warranty = props.warranty;
//       const isWarrantyCreated = props.value["is-warranty-created"];

//       let disableButton;
//       if (warranty === "Yes") disableButton = false;
//       else disableButton = true;

//       return (
//          <tr key={props.keys}>
//             <td>{props.jobCardSerialNo}</td>
//             <td>{jobCardNo === "" ? "-" : jobCardNo}</td>
//             <td>{unitSlNo === "" ? "-" : unitSlNo}</td>
//             <td>{vehicleNo === "" ? "-" : vehicleNo}</td>
//             {props.selectedTOS === "all" && <td>{typeOfService === "" ? "-" : typeOfService}</td>}
//             <td>{warranty}</td>
//             <td>
//                {/* <Link to={`/jobcard?jobcardno=${jobCardNo}`} > */}
//                   <MDBBtn><FontAwesomeIcon icon={faEdit} /></MDBBtn>
//                {/* </Link> */}
//             </td>
//             <td>
//                {/* <Link to={`/warrantycard?jobcardno=${jobCardNo}&mode=${props.value["is-warranty-created"] ? "edit" : "create"}`} > */}
//                   <MDBBtn disabled={disableButton}>{disableButton ? "NA" : (isWarrantyCreated ? "Edit Warranty" : "Create Warranty")}</MDBBtn>
//                {/* </Link> */}
//             </td>
//          </tr>
//       );
//    }
// }

// export default ResultRow;

import React, { Component } from "react";

import { Link } from "react-router-dom";
import axios from "axios";
import { Buffer } from "buffer";
import draftImage from "../images/icons8-draft-60.png";

class ResultRow extends Component {
   constructor(props) {
      super(props);
      this.state = {
         warranty_pdf_report_url: ""
      };
   }

   OpenWarrantyCardReport = async (jobCardNumber) => {
      console.log(jobCardNumber);

      const url = "https://p4d-sutlej.kreativit.in:443/kitmyclients-apis/v1/business_data_manager/RSCS/transactionals?name=warranty_card&job-card-no=" + jobCardNumber;
      console.log(url);
      await axios(url, {
         method: "GET",
         headers: {
            Authorization: "Basic " + Buffer.from("RSCS_admin:admin@scsr").toString("base64"),
            "Auth-Token": "5905d234-34f7-53ce-b192-a886192134ca",
            "Content-Type": "application/json",
            "Accept": "application/json"
         }
      })
         .then(res => res.data)
         .then(resp => {
            console.log(resp.data[0]);
            this.setState({
               warranty_pdf_report_url: resp.data[0]["pdf-report-url"]
            });
            const win = window.open(resp.data[0]["pdf-report-url"], "_blank");
            if (win != null) {
               win.focus();
            }
         })
         .catch(err => console.log(err));
   }

   render() {
      const props = this.props;

      const jobCardNo = props.value["job-card-no"];
      const createdDate = props.value["submit-date"];
      const unitSlNo = props.value["unit-sl-no"];
      const vehicleNo = props.value["vehicle-no"];
      const warranty = props.warranty;
      const isWarrantyCreated = props.value["is-warranty-created"];
      const pdf_report_url = props.value["pdf-report-url"];
      const isSubmissionDone = props.value["is-submission-done"];

      return (
         <tr key={props.keys}>
            <td style={{ height: "10px", padding: "8px 0" }}>{jobCardNo === "" ? "-" : jobCardNo}</td>
            <td style={{ height: "10px", padding: "8px 0" }}>{createdDate}</td>
            <td style={{ height: "10px", padding: "8px 0" }}>{unitSlNo === "" ? "-" : unitSlNo}</td>
            <td style={{ height: "10px", padding: "8px 0" }}>{vehicleNo === "" ? "-" : vehicleNo}</td>
            <td style={{ height: "10px", padding: "0 0" }}>
               <svg style={{ height: "44px", padding: "8px 0" }} viewBox="0 0 512 512"><path d="M373.1 24.97C401.2-3.147 446.8-3.147 474.9 24.97L487 37.09C515.1 65.21 515.1 110.8 487 138.9L289.8 336.2C281.1 344.8 270.4 351.1 258.6 354.5L158.6 383.1C150.2 385.5 141.2 383.1 135 376.1C128.9 370.8 126.5 361.8 128.9 353.4L157.5 253.4C160.9 241.6 167.2 230.9 175.8 222.2L373.1 24.97zM440.1 58.91C431.6 49.54 416.4 49.54 407 58.91L377.9 88L424 134.1L453.1 104.1C462.5 95.6 462.5 80.4 453.1 71.03L440.1 58.91zM203.7 266.6L186.9 325.1L245.4 308.3C249.4 307.2 252.9 305.1 255.8 302.2L390.1 168L344 121.9L209.8 256.2C206.9 259.1 204.8 262.6 203.7 266.6zM200 64C213.3 64 224 74.75 224 88C224 101.3 213.3 112 200 112H88C65.91 112 48 129.9 48 152V424C48 446.1 65.91 464 88 464H360C382.1 464 400 446.1 400 424V312C400 298.7 410.7 288 424 288C437.3 288 448 298.7 448 312V424C448 472.6 408.6 512 360 512H88C39.4 512 0 472.6 0 424V152C0 103.4 39.4 64 88 64H200z" /></svg>
               {
                  isSubmissionDone === "true" ?
                     <a href={pdf_report_url} target="_blank">
                        <svg style={{ height: "44px", padding: "8px 40px 8px" }} viewBox="0 0 384 512"><path d="M88 304H80V256H88C101.3 256 112 266.7 112 280C112 293.3 101.3 304 88 304zM192 256H200C208.8 256 216 263.2 216 272V336C216 344.8 208.8 352 200 352H192V256zM224 0V128C224 145.7 238.3 160 256 160H384V448C384 483.3 355.3 512 320 512H64C28.65 512 0 483.3 0 448V64C0 28.65 28.65 0 64 0H224zM64 224C55.16 224 48 231.2 48 240V368C48 376.8 55.16 384 64 384C72.84 384 80 376.8 80 368V336H88C118.9 336 144 310.9 144 280C144 249.1 118.9 224 88 224H64zM160 368C160 376.8 167.2 384 176 384H200C226.5 384 248 362.5 248 336V272C248 245.5 226.5 224 200 224H176C167.2 224 160 231.2 160 240V368zM288 224C279.2 224 272 231.2 272 240V368C272 376.8 279.2 384 288 384C296.8 384 304 376.8 304 368V320H336C344.8 320 352 312.8 352 304C352 295.2 344.8 288 336 288H304V256H336C344.8 256 352 248.8 352 240C352 231.2 344.8 224 336 224H288zM256 0L384 128H256V0z" /></svg>
                     </a>
                     :
                     <img style={{ height: "44px", padding: "8px 36px 8px" }} src={draftImage} />
               }
            </td>

            <td style={{ height: "10px", padding: "0 0" }}>
               {
                  warranty === "Yes" ?
                     <div>
                        {
                           isWarrantyCreated === "true" ?
                              <div>
                                 {/* <Link to={`/warrantycard?jobcardno=${jobCardNo}&mode=${props.value["is-warranty-created"] === "true" ? "edit" : "create"}`} >                                */}
                                 <svg style={{ height: "44px", padding: "8px 0" }} viewBox="0 0 512 512"  ><path d="M373.1 24.97C401.2-3.147 446.8-3.147 474.9 24.97L487 37.09C515.1 65.21 515.1 110.8 487 138.9L289.8 336.2C281.1 344.8 270.4 351.1 258.6 354.5L158.6 383.1C150.2 385.5 141.2 383.1 135 376.1C128.9 370.8 126.5 361.8 128.9 353.4L157.5 253.4C160.9 241.6 167.2 230.9 175.8 222.2L373.1 24.97zM440.1 58.91C431.6 49.54 416.4 49.54 407 58.91L377.9 88L424 134.1L453.1 104.1C462.5 95.6 462.5 80.4 453.1 71.03L440.1 58.91zM203.7 266.6L186.9 325.1L245.4 308.3C249.4 307.2 252.9 305.1 255.8 302.2L390.1 168L344 121.9L209.8 256.2C206.9 259.1 204.8 262.6 203.7 266.6zM200 64C213.3 64 224 74.75 224 88C224 101.3 213.3 112 200 112H88C65.91 112 48 129.9 48 152V424C48 446.1 65.91 464 88 464H360C382.1 464 400 446.1 400 424V312C400 298.7 410.7 288 424 288C437.3 288 448 298.7 448 312V424C448 472.6 408.6 512 360 512H88C39.4 512 0 472.6 0 424V152C0 103.4 39.4 64 88 64H200z" /></svg>
                                 {/* </Link> */}
                                 <a onClick={() => this.OpenWarrantyCardReport(jobCardNo)} >
                                    <svg style={{ height: "44px", padding: "8px 40px 8px" }} viewBox="0 0 384 512"><path d="M88 304H80V256H88C101.3 256 112 266.7 112 280C112 293.3 101.3 304 88 304zM192 256H200C208.8 256 216 263.2 216 272V336C216 344.8 208.8 352 200 352H192V256zM224 0V128C224 145.7 238.3 160 256 160H384V448C384 483.3 355.3 512 320 512H64C28.65 512 0 483.3 0 448V64C0 28.65 28.65 0 64 0H224zM64 224C55.16 224 48 231.2 48 240V368C48 376.8 55.16 384 64 384C72.84 384 80 376.8 80 368V336H88C118.9 336 144 310.9 144 280C144 249.1 118.9 224 88 224H64zM160 368C160 376.8 167.2 384 176 384H200C226.5 384 248 362.5 248 336V272C248 245.5 226.5 224 200 224H176C167.2 224 160 231.2 160 240V368zM288 224C279.2 224 272 231.2 272 240V368C272 376.8 279.2 384 288 384C296.8 384 304 376.8 304 368V320H336C344.8 320 352 312.8 352 304C352 295.2 344.8 288 336 288H304V256H336C344.8 256 352 248.8 352 240C352 231.2 344.8 224 336 224H288zM256 0L384 128H256V0z" /></svg>
                                 </a>
                              </div>
                              :
                              // <Link to={`/warrantycard?jobcardno=${jobCardNo}&mode=${props.value["is-warranty-created"] === "true" ? "edit" : "create"}`} >
                              <svg style={{ height: "44px", padding: "8px 110px 8px 8px" }} viewBox="0 0 448 512" ><path d="M200 344V280H136C122.7 280 112 269.3 112 256C112 242.7 122.7 232 136 232H200V168C200 154.7 210.7 144 224 144C237.3 144 248 154.7 248 168V232H312C325.3 232 336 242.7 336 256C336 269.3 325.3 280 312 280H248V344C248 357.3 237.3 368 224 368C210.7 368 200 357.3 200 344zM0 96C0 60.65 28.65 32 64 32H384C419.3 32 448 60.65 448 96V416C448 451.3 419.3 480 384 480H64C28.65 480 0 451.3 0 416V96zM48 96V416C48 424.8 55.16 432 64 432H384C392.8 432 400 424.8 400 416V96C400 87.16 392.8 80 384 80H64C55.16 80 48 87.16 48 96z" /></svg>
                           // </Link>
                        }
                     </div>
                     :
                     <div style={{ height: "44px", padding: "8px 110px 8px 8px", fontWeight: "bold" }}>NA</div>
               }
            </td>
         </tr>
      );
   }
}

export default ResultRow;
